import { Switch, Typography } from '@navi/web-ui/lib/primitives';
import { DateFormat, dateFormat } from '@cp/src/utils/DateHelper';

type ActiveInactiveWrapperProps = {
  styles: CSSModuleClasses;
  emailAddress: string;
  updatedAt: string;
  isAgentActive: boolean;
  toggleAgentActive: () => void;
  isEditDisabled: boolean;
  dashedLineColor?: string;
};

const ActiveInactiveWrapper = (props: ActiveInactiveWrapperProps) => {
  const {
    styles,
    emailAddress,
    updatedAt,
    isAgentActive,
    toggleAgentActive,
    isEditDisabled,
    dashedLineColor = 'var(--navi-color-gray-c3)'
  } = props;

  return (
    <div className={styles.editContainer}>
      {emailAddress ? (
        <div className={styles.emailIdContainer}>
          <Typography variant="h5" color="var(--navi-color-gray-c3)">
            Email ID
          </Typography>

          <Typography variant="p3" color="var(--navi-color-gray-c1)">
            {emailAddress}
          </Typography>
        </div>
      ) : (
        <div className="ml-[20px] pt-[10px] w-[100%] items-center">
          <Typography variant="h5" color="var(--navi-color-gray-c3)">
            Status
          </Typography>
        </div>
      )}
      <div className={styles.activeButtonContainer}>
        <Switch checked={isAgentActive} onChange={toggleAgentActive} disabled={isEditDisabled} />
        <>
          {isAgentActive ? (
            <Typography variant="p3" color="var(--navi-color-gray-c2)">
              Active
            </Typography>
          ) : (
            <>
              <Typography variant="p3" color="var(--navi-color-gray-c2)">
                Inactive
              </Typography>
              <Typography variant="p3" color="var(--navi-color-navigation-blue-c2)">
                |
              </Typography>
              <Typography variant="p3" color="var(--navi-color-gray-c2)">
                Since{' '}
                {dateFormat(new Date(updatedAt ?? ''), DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)}
              </Typography>
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default ActiveInactiveWrapper;
